<template>
  <div>
    <Calendar :tasks="tasks" :showCalendarsList="true"></Calendar>
  </div>
</template>

<script>
import Calendar from 'CORE/components/calendar'

export default {
    name: 'CalendarView',
    components: {
        Calendar,
    },
    data: function() {
        return {
        }
    },
    computed: {
        tasks() {
            return this.$store.getters.tasks
        },
    },
}
</script>
